import { type NewsItem } from '@/api/types';
import { useLocale } from '@/hooks/useLocale';
import { formatDate } from '@/utils/date';
import styles from './NewsCard.module.css';

interface NewsCardProps {
  item: NewsItem;
  onClick?: () => void;
  variant?: 'wide' | 'inline';
}

export function NewsCard({ item, onClick, variant = 'wide' }: NewsCardProps): JSX.Element {
  const { locale } = useLocale();
  return (
    <article className={`${styles.card} ${styles[variant]}`} onClick={onClick} role="button">
      {item.image_url && (
        <div
          className={styles.cover}
          style={{ backgroundImage: `url(${item.image_url})` }}
          aria-hidden
        />
      )}
      <div className={styles.body}>
        <h3 className={styles.title}>{item.title}</h3>
        {item.snippet && <p className={styles.snippet}>{item.snippet}</p>}
        <div className={styles.meta}>
          <span className={styles.source}>{item.source_name}</span>
          <span className={styles.sep}>•</span>
          <time>{formatDate(item.published_at, locale)}</time>
        </div>
      </div>
    </article>
  );
}
